import _slicedToArray from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React, { useState, useRef, useEffect } from "react";

var ProgressBar = function ProgressBar(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "#1ce" : _ref$color,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 4 : _ref$height,
      _ref$direction = _ref.direction,
      direction = _ref$direction === void 0 ? "right" : _ref$direction,
      _ref$position = _ref.position,
      position = _ref$position === void 0 ? "top" : _ref$position,
      _ref$gradient = _ref.gradient,
      gradient = _ref$gradient === void 0 ? false : _ref$gradient,
      _ref$gradientColor = _ref.gradientColor,
      gradientColor = _ref$gradientColor === void 0 ? "yellow" : _ref$gradientColor;

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      scroll = _useState2[0],
      setScroll = _useState2[1];

  var ticking = useRef(false);
  useEffect(function () {
    document.addEventListener("scroll", updateProgressBar);
    updateProgressBar();
    return function () {
      return document.removeEventListener("scroll", updateProgressBar);
    };
  }, []);

  var updateProgressBar = function updateProgressBar() {
    if (!ticking.current) {
      var windowHeight = document.documentElement.offsetHeight - window.innerHeight;
      window.requestAnimationFrame(function () {
        setScroll(Math.floor(window.pageYOffset / windowHeight * 100));
        ticking.current = false;
      });
    }

    ticking.current = true;
  };

  return /* @__PURE__ */React.createElement("div", {
    style: {
      position: "fixed",
      left: 0,
      right: 0,
      height: height,
      zIndex: 999,
      top: position === "top" ? 0 : "unset",
      bottom: position === "bottom" ? 0 : "unset",
      background: gradient ? "linear-gradient(to ".concat(direction, ", ").concat(color, " ").concat(scroll / 2, "%,").concat(gradientColor, " ").concat(scroll, "%, transparent 0)") : "linear-gradient(to ".concat(direction, ", ").concat(color, " ").concat(scroll, "%, transparent 0)")
    }
  });
};

export { ProgressBar as default };